import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';

import { Flex, Text, Progress } from '@pega/cosmos-react-core';

import { loadingTimeoutMS } from '../Progress/Progress.mocks';

export const PinContent = ({
  content,
  mockFetching
}: {
  content: string;
  mockFetching?: boolean;
}) => {
  const [fetchedContent, setFetchedContent] = useState<ReactNode | undefined>();

  useEffect(() => {
    // Mocking a network request to fetch data
    const timeout = window.setTimeout(
      () => {
        setFetchedContent(
          <Flex container={{ direction: 'column', gap: 2 }}>
            <Text as='p'>{content}</Text>
            <Text as='p'>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
              dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
              mollit anim id est laborum.
            </Text>
          </Flex>
        );
      },
      mockFetching ? loadingTimeoutMS : 0
    );

    return () => {
      window.clearTimeout(timeout);
    };
  }, []);

  return <>{fetchedContent || <Progress visible focusOnVisible placement='local' />}</>;
};
